
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "OurTransportBannerBlock",

  head: function () {
    let links = [
      {
        as: "image",
        rel: "preload",
        href: this.mainImage,
        type: "image/webp",
        media: "(max-width: 1024px)"
      }
    ];

    return {
      link: links
    }
  },

  computed: {
    title: function () {
      const catsTitle = (this.values?.cats_titles || []).find((t) => t.category === this.externalData?.OurTransportBannerBlock?.categoryId)?.title;
      return catsTitle || this.externalData?.OurTransportBannerBlock?.title || this.values.title || "";
    },
    image: function () {
      return this.externalData?.OurTransportBannerBlock?.image ||  this.values.image || "";
    },
    information: function () {
      return this.externalData?.OurTransportBannerBlock?.information ||  this.values.information || [];
    },
    mainImage: function () {
      let width = 640;

      if (!this.image) {
        return ""
      }
      return this.$img(String(this.image), {
        width: width,
        fit: 'cover'
      })
    },

    isVisible: function () {
      const device = this.$store.state.device?.device;

      const isMobile = Boolean(this.cfgs?.visible_mobile && device?.isMobile);
      const isTablet = Boolean(this.cfgs?.visible_laptop && device?.isTablet);
      const isDesktop = Boolean(this.cfgs?.visible_pc && device?.isDesktop);

      return Boolean(isMobile || isTablet || isDesktop)
    }
  },

  methods: {
    openFormFeedBack: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Заказать звонок',
          hideTabs: true,
        }
      });
    },
  }
});
